import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=a2b8de34&scoped=true"
import script from "./activityDetails.vue?vue&type=script&lang=js"
export * from "./activityDetails.vue?vue&type=script&lang=js"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=a2b8de34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b8de34",
  null
  
)

export default component.exports